// pages/index.js

import React, { useState, useEffect } from 'react';
import NameAvailability from './NameAvailability';
import accountExists from 'helpers/accountExists';
import validateAccountName from 'helpers/validateAccountName';

export default function HiveAvailability({ username }) {
  const [availability, setAvailability] = useState(null);

  const checkHiveNameAvailability = async username => {
    if (validateAccountName(username)) return setAvailability(false);
    return accountExists(username)
      .then(res => {
        setAvailability(!res);
      })
      .catch(err => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (username) {
      checkHiveNameAvailability(username);
    }
  }, [username]);

  return (
    <div>
      <NameAvailability
        isAvailable={availability}
        name={username}
        platform="Hive"
      />
    </div>
  );
}
